import {showSystemNoti} from "@/shared/helper";
import jwtInterceptor from '@/shared/jwtInterceptor';

let HOST = process.env.VUE_APP_API_URL;
let basePath = process.env.VUE_APP_API_PATH;
let $ = window.$
  // ,jQuery = window.$;

// function closeAjaxModal()
// {
//
// }

let fileManager={
  initiated:false,
  files:{},
  options:{
    baseUrl:HOST+basePath,
    uploadRoute:'Filemanager/Upload',
    getFilesRoute:'Filemanager/GetFiles',
    deleteFileRoute:'Filemanager/Delete/',
    saveFileInfoRoute:'Filemanager/SaveInfo/',
    watermarkRoute:'Filemanager/watermark/',
    cropModalRoute:'Filemanager/cropModal/',
    storageUrl:HOST+'/storage/uploads/',
    fileTypes:['image','video','audio'],
    showLoading:false,
    assetsUrl: HOST+basePath+'assets/',
    imgUrl: HOST+'/panel/img/'
  },
  html:{

    fileItem:`
<div class="col col-md-3 col-sm-4 col-6">
  <div class="file-item" id="file-item-[[id]]" data-id="[[id]]">
    <div class="thumbnail">[[thumbnail]]</div>
    <div class="title">[[title]]</div>
    <button type="button" class="check" tabindex="0"><span class="media-modal-icon"></span><span
        class="screen-reader-text">گزینش نکردن</span></button>
  </div>
</div>`,

    fileInfo:`
<div data-id="[[id]]" class="attachment-details"><h2>جزییات فایل</h2>
  <div class="attachment-info">
    <div class="thumbnail"><img src="[[thumbnail]]" class="icon" draggable="false"></div>
    <div class="details">
      <div class="filename">[[name]]</div>
      <div class="uploaded">[[upload_date]]</div>
      <div class="file-size">[[file_size]]</div>
      <button type="button" class="btn btn-danger waves-effect deleteButton" data-action="[[delete_route]]"
              data-title="[[title]]" data-response="deleteFileCallback">پاک کردن برای همیشه
      </button>
    </div>
  </div>
  <hr/>
  <form class="ajax-form form-horizontal" data-action="[[save_route]]" data-response="fileManagerSaveInfoCallback">
    <div><label class="setting"> <span class="name">عنوان</span><input type="text" class="form-control" name="title"
                                                                       value="[[title]]"> </label></div>
    <div><label class="setting"> <span class="name">متن جایگزین</span><input class="form-control" name="alt"
                                                                             value="[[alt]]"/><input type="hidden"
                                                                                                     name="index"
                                                                                                     value="[[index]]"/>
    </label></div>
    <div><label class="setting"> <span class="name">لینک</span><input class="form-control" type="url" name="link"
                                                                      value="[[link]]"/> </label></div>
    <div><label class="setting"> <span class="name">توضیح</span><textarea name="content"
                                                                          class="form-control">[[content]]</textarea></label>
    </div>
    <div><label class="setting"> <span class="name">کپی پیوند</span><input type="text" class="form-control"
                                                                           onclick="this.select()" value="[[url]]"
                                                                           readonly=""/> </label></div>
    <div><label class="setting">
      <button type="submit" class="btn btn-success">ذخیره اطلاعات</button>
    </label></div>
  </form>
</div>`,

    fileManager:`
<div id="filemanager-modal-overlay"></div>
<div id="filemanager-modal">
  <div class="filemanager-modal-header">
    <div class="title"><h2>[[title]]</h2></div>
    <div id="close-filemanager-modal"><i class="fa fa-times-circle"></i></div>
    <ul class="nav md-tabs nav-justified" role="tablist">
      <li class="nav-item waves-effect waves-light" role="presentation">
        <button id="upload-trigger" class="nav-link">بارگذاری فایل</button>
        <input id="upload-file-input" type="file" style="display: none" />
      </li>
<!--      <li class="nav-item waves-effect waves-light" role="presentation"><a class="nav-link active"-->
<!--                                                                           href="#filemanager-uploaded-files-list"-->
<!--                                                                           data-toggle="tab">فایل های آپلود شده</a></li>-->
    </ul>
  </div>
  <div class="filemanager-modal-body">
    <div class="filemanager-wrapper">
      <div class="filemanager-container">
        <div class="tab-content">
          <div role="tabpanel" class="tab-pane fade " id="filemanager-upload-file">
            <form action="[[uploadRoute]]" id="frmFileUpload" class="dropzone" method="post"
                  enctype="multipart/form-data">
              <div class="dz-message">
                <div class="drag-icon-cph"><i class="fa fa-upload"></i></div>
                <h3>برای آپلود فایل آنها را کشیده و در اینجا رها کنید و یا اینجا کلیک کنید</h3></div>
              <div class="fallback"><input name="files" type="file" multiple/></div>
            </form>
          </div>
          <div role="tabpanel" class="tab-pane fade in active show filemanager-list-files-wrapper [[multiple]]"
               id="filemanager-uploaded-files-list">
            <div class="row">
              <div class="col col-md-9 col-sm-9 col-12">
                <div class="row">
                  <div class="col-md-4 col-sm-12 col-12"></div>
                  <div class="col-md-4 col-sm-6 col-12">[[typeSelect]]</div>
                  <div class="col-md-4 col-sm-6 col-12"><input type="text" class="form-control" id="filemanagerQuery"/>
                  </div>
                </div>
                <div class="clearfix"></div>
                <div class="filemanager-list-files row"></div>
              </div>
              <div class="col col-md-3 col-sm-3 col-12">
                <a class="show-file-info-btn closed"><i class="fa fa-caret-left"></i></a>
                <div class="file_info closed"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="filemanager-modal-footer">
    <div class="float-right">
      <div class="filemanager-files-pagination"></div>
    </div>
    <div class="float-left">
      <button id="filemanager-select-item" class="btn waves-effect btn-primary">انتخاب</button>
    </div>
  </div>
</div>`,

    pureFileManager: `
<ul class="nav md-tabs nav-justified" role="tablist">
  <li class="nav-item waves-effect waves-light" role="presentation">
    <a class="nav-link" href="#filemanager-upload-file" data-toggle="tab">بارگذاری فایل</a>
  </li>
<!--  <li class="nav-item waves-effect waves-light" role="presentation">-->
<!--    <a class="nav-link active" href="#filemanager-uploaded-files-list" data-toggle="tab">فایل های آپلود شده</a>-->
<!--  </li>-->
</ul>

<div class="filemanager-modal-body">
    <div class="filemanager-wrapper">
  <div class="filemanager-container">
    <div class="tab-content">
      <div role="tabpanel" class="tab-pane fade " id="filemanager-upload-file">
        <form action="[[uploadRoute]]" id="frmFileUpload" class="dropzone" method="post" enctype="multipart/form-data">
          <div class="dz-message">
            <div class="drag-icon-cph"><i class="fa fa-upload"></i></div>
            <h3>برای آپلود فایل آنها را کشیده و در اینجا رها کنید و یا اینجا کلیک کنید</h3></div>
          <div class="fallback"><input name="files" type="file" multiple/></div>
        </form>
      </div>
      <div role="tabpanel" class="tab-pane fade in active show filemanager-list-files-wrapper [[multiple]]"
           id="filemanager-uploaded-files-list">
        <div class="row">
          <div class="col col-md-9 col-sm-9 col-12">
            <div class="row">
              <div class="col-md-4 col-sm-12 col-12"><select class="selectpicker ajax" data-live-search="true"
                                                             data-route="Filemanager/SuggestFileLibrary">
                <option value="all" selected>همه</option>
                <option value="self">فقط خودم</option>
              </select></div>
              <div class="col-md-4 col-sm-6 col-12">[[typeSelect]]</div>
              <div class="col-md-4 col-sm-6 col-12"><input type="text" class="form-control" id="filemanagerQuery"/>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="filemanager-list-files row"></div>
          </div>
          <div class="col col-md-3 col-sm-3 col-12">
                <a class="show-file-info-btn closed"><i class="fa fa fa-caret-left"></i></a>
                <div class="file_info closed"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>

<div class="filemanager-modal-footer">
  <div class="float-right">
  <div class="filemanager-files-pagination"></div>
  </div>
  <div class="float-left">
    <button id="filemanager-select-item" class="btn waves-effect btn-primary">انتخاب</button>
  </div>
</div>`
  }
};
// fileManager.makeRequest=async function makeRequest(url, data,showLoadModal, title, callback) {
//   if (typeof showLoadModal==="undefined")
//     showLoadModal=true;
//
//   let contentType='application/x-www-form-urlencoded; charset=UTF-8';
//   if (typeof data!=="string")
//   {
//     contentType='application/json';
//     data = JSON.stringify(data);
//   }
//
//   if (typeof title !== 'string')
//     title = '';
//
//   if (typeof url === 'string') {
//     if (showLoadModal) {
//       if (!$('#ajaxLinkModal').length) {
//         let html = '<div style="display: none;" class="modal fade" id="ajaxLinkModal" tabindex="-1" role="dialog" aria-labelledby="ajaxLinkModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">\n' +
//           '\t<div class="modal-dialog">\n' +
//           '\t\t<div class="modal-content">\n' +
//           '\t\t\t<div class="modal-header" align="center">\n' +
//           '\t\t\t\t<h4 class="modal-title">' + title + '</h4>\n' +
//           '\t\t\t</div>\n' +
//           '\t\t\t<div class="modal-body" align="right">\n' +
//           '\t\t\t\n' + '<div class="center"><img src="' + HOST+basePath + 'WaiterAssets/img/loading.gif" style="width:60px;" /> </div>' +
//           '\t\t\t</div>\n' +
//           '\t\t\t<div class="modal-footer center">\n' +
//           '\t\t\t\n' + '<button type="button" class="btn btn-block btn-raised btn-warning" onclick="closeAjaxModal()">بستن</button> ' +
//           '\t\t\t</div>\n' +
//           '\t </div>\n' +
//           '\t</div>\n' +
//           '</div>';
//         $('body').prepend(html);
//         $('#ajaxLinkModal').modal('toggle');
//       }
//       else {
//         $('#ajaxLinkModal .modal-body').html('<div class="center"><img src="' + HOST + basePath + 'WaiterAssets/img/loading.gif" style="width:60px;" /> </div>');
//         $('#ajaxLinkModal').modal('toggle');
//       }
//     }
//
//     return jQuery.ajax({
//       url: url,
//       data: data,
//       headers: {
//         'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
//       },
//       contentType: contentType,
//       cache: false,
//       method: 'POST',
//       success: function (data)
//       {
//         let time = 5;
//         if (showLoadModal)
//           time = 500;
//         closeAjaxModal();
//         setTimeout(function ()
//         {
//           if (typeof callback === "function")
//           {
//             callback(data);
//           }
//           else if (typeof window[callback] === "function")
//           {
//             window[callback](data);
//           }
//           else
//           {
//             if (typeof data.result === 'string' && typeof data.message === 'string')
//               showSystemNoti(data.result, data.message);
//           }
//           return data;
//         }, time);
//       },
//       fail: function ()
//       {
//         let time = 5;
//         if (showLoadModal)
//           time = 500;
//         setTimeout(function ()
//         {
//           showSystemNoti('danger', 'خطا در برقراری ارتباط با سرور');
//         }, time);
//       },
//       complete: function (xhr)
//       {
//         if (xhr.status !== 200)
//         {
//           closeAjaxModal();
//           let time = 20;
//           if (showLoadModal)
//             time = 500;
//           setTimeout(function ()
//           {
//             showSystemNoti('danger', 'درخواست مورد نظر معتبر نیست.');
//           }, time);
//         }
//       }
//     });
//   }
// };
fileManager.notify=function(type,text)
{
  try
  {
    showSystemNoti(type,text)
  }
  catch (e)
  {
    console.log(e)
  }
};
fileManager.renderFiles=function(result,prepend)
{
  console.log(result);
  if (result!==undefined)
  {
    if (result.ok)
    {
      if (typeof result.files !== 'undefined')
      {
        let files = result.files;
        for (let i = 0; i < files.length; i++)
        {
          if (typeof this.files[files[i]._id] === "undefined")
          {
            let file = files[i];
            file.url = this.options.storageUrl+file.name;
            this.files[file._id] = file;

            let thumbnail = this.options.imgUrl + 'document.png';
            if (file.type === 'image')
              thumbnail = this.options.storageUrl + file.thumbnail;
              // thumbnail = this.options.storageUrl + file.name;
            else if (file.type === 'audio')
              thumbnail = this.options.imgUrl + 'audio.png';
            else if (file.type === 'video')
              thumbnail = this.options.imgUrl + 'video.png';
            thumbnail='<img src="'+thumbnail+'" />';

            let html = this.html.fileItem;
            html = html.replace('[[id]]', file._id);
            html = html.replace('[[id]]', file._id);
            html = html.replace('[[thumbnail]]', thumbnail);
            html = html.replace('[[title]]', file.local_name);

            if (prepend)
              $('.filemanager-list-files').prepend(html);
            else
              $('.filemanager-list-files').append(html);
          }
        }

        if (prepend)
          return;
        //rendering pagination
        let total = result.total;
        let perPage = result.perPage;
        let lastPage = Math.ceil(total/perPage);
        let currentPage = Math.floor(result.offset/result.perPage);
        currentPage++;

        let paginationHtml = '<ul class="pagination pagination-circle pg-blue mb-0">';

        let j;
        let n;
        let lastPrintedPage;

        //begining part
        if (currentPage > 5)
        {
          paginationHtml+='<li class="page-item"><a class="page-link waves-effect waves-effect" data-offset="0">1</a></li>';
          paginationHtml+='<li class="page-item"><a class="page-link waves-effect waves-effect" data-offset="'+(perPage)+'">2</a></li>';
          paginationHtml+='<li>...</li>';
          n=Math.min(lastPage,(currentPage+2));
          for (j = (currentPage-2); j <= n; j++)
          {
            lastPrintedPage=j;
            paginationHtml+='<li '+(j===currentPage?'class="page-item active"':'class="page-item"')+'><a class="page-link waves-effect waves-effect" data-offset="'+((j-1)*perPage)+'">'+j+'</a></li>';
          }
        }
        else
        {
          n=Math.min(lastPage,(currentPage+2));
          for (j = 1; j <= n; j++)
          {
            lastPrintedPage=j;
            paginationHtml+='<li '+(j===currentPage?'class="page-item active"':'class="page-item"')+'><a class="page-link waves-effect waves-effect" data-offset="'+((j-1)*perPage)+'">'+j+'</a></li>';
          }
        }

        //end part
        if (lastPrintedPage < (lastPage - 2))
        {
          paginationHtml+='<li>...</li>';
          for (j = (lastPage - 1); j <= lastPage; j++)
          {
            lastPrintedPage=j;
            paginationHtml+='<li class="page-item"><a class="page-link waves-effect waves-effect" data-offset="'+((j-1)*perPage)+'">'+j+'</a></li>';
          }
        }
        else
        {
          for (j = (lastPrintedPage+1); j <= lastPage; j++)
          {
            lastPrintedPage=j;
            paginationHtml+='<li class="page-item"><a class="page-link waves-effect waves-effect" data-offset="'+((j-1)*perPage)+'">'+j+'</a></li>';
          }
        }

        paginationHtml+='</ul>';
        $('.filemanager-files-pagination').html(paginationHtml);
      }
      else
        this.notify('danger', 'خطای سرور')
    }
    else
    {
      if (typeof result.error === "string")
        this.notify('danger', result.error);
      else
        this.notify('danger', 'خطای سرور')
    }
  }
  else
    this.notify('danger', 'خطا در برقراری ارتباط با سرور')
};
fileManager.getFiles=async function (offset, number, type,query)
{
  if (typeof type === 'undefined' || this.options.fileTypes.indexOf(type)<0)
    type = 'all';
  let data='offset='+offset+'&number='+number;
  if (type !== 'all')
    data+='&type='+type;
  if (typeof query !== 'undefined' && query!=null)
    data+='&query='+query;

  // let result =await this.makeRequest(this.options.baseUrl+this.options.getFilesRoute,data,this.options.showLoading);
  const url = process.env.VUE_APP_API_URL+process.env.VUE_APP_API_PATH+fileManager.options.getFilesRoute;
  try
  {
    const result = await jwtInterceptor.post(url,data);
    if (result && result.data)
      this.renderFiles(result.data)
  }
  catch (e)
  {
    console.log(e)
  }
};
fileManager.getSize=function (size)
{
  if (typeof size === "undefined")
    return 'نامشخص';
  let unit;
  let newSize;
  size = parseInt(size);

  unit = 'B';
  newSize=size/1024;
  if (newSize<1)
    return (Math.round(size * 100) / 100)+' '+unit;
  size=newSize;

  unit = 'KB';
  newSize=size/1024;
  if (newSize<1)
    return (Math.round(size * 100) / 100)+' '+unit;
  size=newSize;

  unit = 'MB';
  newSize=size/1024;
  if (newSize<1)
    return (Math.round(size * 100) / 100)+' '+unit;
  size=newSize;

  unit = 'GB';
  newSize=size/1024;
  if (newSize<1)
    return (Math.round(size * 100) / 100)+' '+unit;
  size=newSize;

  unit = 'TB';
  newSize=size/1024;
  if (newSize<1)
    return (Math.round(size * 100) / 100)+' '+unit;
  return 'نامشخص';
};
fileManager.showFileInfo=function(id)
{
  if (typeof this.files[id]!=="undefined")
  {
    let file = this.files[id];
    let deleteRoute=this.options.deleteFileRoute+file._id;
    let saveRoute = this.options.saveFileInfoRoute+file._id;
    let watermarkRoute = this.options.watermarkRoute+file._id;
    let cropModalRoute = this.options.cropModalRoute+file._id;
    let url=this.options.storageUrl+file.name;
    let thumbnail = this.options.imgUrl+'document.png';
    if (file.type === 'image')
      thumbnail = this.options.storageUrl+file.thumbnail;
    else if (file.type === 'audio')
      thumbnail = this.options.imgUrl+'audio.png';
    else if (file.type === 'video')
      thumbnail = this.options.imgUrl+'video.png';
    let watermarkBtnText='ثبت واترمارک';
    let watermarkBtnClass='success';
    if (file.watermarked)
    {
      watermarkBtnText='حذف واترمارک';
      watermarkBtnClass='danger';
    }

    let html = this.html.fileInfo;
    html = html.replace('[[id]]',file._id);
    html = html.replace('[[index]]',id);
    html = html.replace('[[thumbnail]]',thumbnail);
    html = html.replace('[[name]]',file.title);
    html = html.replace('[[upload_date]]',file.created_at);
    html = html.replace('[[delete_route]]',deleteRoute);
    html = html.replace('[[file_size]]',this.getSize(file.size));
    html = html.replace('[[save_route]]',saveRoute);
    html = html.replace('[[title]]',file.title);
    html = html.replace('[[title]]',file.title);
    html = html.replace('[[alt]]',file.alt);
    html = html.replace('[[link]]',file.link?file.link:'');
    html = html.replace('[[content]]',file.content);
    html = html.replace('[[watermark_route]]',watermarkRoute);
    html = html.replace('[[crop_modal_route]]',cropModalRoute);
    html = html.replace('[[watermark_btn_class]]',watermarkBtnClass);
    html = html.replace('[[watermark_btn_text]]',watermarkBtnText);
    html = html.replace('[[url]]',url);
    $('.file_info').html(html).removeClass('closed');
    $('.file_info').siblings('.show-file-info-btn').removeClass('closed');
  }
};
fileManager.clearFileList=function()
{
  this.files={};
  $('.filemanager-list-files').html('');
};
fileManager.showFilemanagerModal=function (loadFiles, fileType) {
  $('#filemanager-modal-overlay').fadeIn();
  $('body').toggleClass('filemanager-is-open');
  $('#filemanager-modal').fadeIn();
  if (loadFiles)
  {
    if (!fileType)
      fileType=null;
    this.getFiles(0,20,fileType);
  }
};
fileManager.hideFilemanagerModal=function () {
  $('#filemanager-modal-overlay').fadeOut();
  $('#filemanager-modal').fadeOut();
  $('body').toggleClass('filemanager-is-open');
};
fileManager.init=function (title,multiple,onlyImage,targetElementSelector)
{
  let multipleClass = '';
  let typeSelect = '<select id="filemanagerTypeSelect" class="selectpicker">\n' +
    '                      <option value="all">همه فایل ها</option>\n' +
    '                      <option value="image">تصاویر</option>\n' +
    '                      <option value="video">فایل های ویدیویی</option>\n' +
    '                      <option value="audio">فایل های صوتی</option>\n' +
    '                    </select>';
  if (onlyImage)
    typeSelect='<input type="hidden" id="filemanagerTypeSelect" value="image" />';
  if (!title)
    title='فایل های چندرسانه ای';
  if (multiple)
  {
    multipleClass ='multiple'
  }

  if (!this.initiated)
  {

    let flag = true;

    if (targetElementSelector)
    {
      console.log(targetElementSelector);
      if ($(targetElementSelector).length)
      {
        console.log('here');
        flag = false;

        let html = this.html.pureFileManager;
        html = html.replace('[[uploadRoute]]', HOST+basePath+this.options.uploadRoute);
        html = html.replace('[[typeSelect]]', typeSelect);
        html = html.replace('[[multiple]]', multipleClass);
        html = html.replace('[[title]]', title);

        $(targetElementSelector).html(html);
        let fileType = null;
        if (onlyImage)
          fileType='image';
        let query = $('#filemanagerQuery').val();
        let ownerUserId = $('#filemanager-files-owner').val();

        const fileAccess = $('meta[name="filemanager-access"]').attr('content');
        if (fileAccess !== 'all')
          $('#filemanager-files-owner').remove();

        this.getFiles(0,20,fileType,query,ownerUserId);
      }
    }

    if (flag)
    {
      let html = this.html.fileManager;
      html = html.replace('[[uploadRoute]]', HOST+basePath+this.options.uploadRoute);
      html = html.replace('[[typeSelect]]', typeSelect);
      html = html.replace('[[multiple]]', multipleClass);
      html = html.replace('[[title]]', title);

      $('body').prepend(html);
      const fileAccess = $('meta[name="filemanager-access"]').attr('content');

      if (fileAccess !== 'all')
        $('#filemanager-files-owner').remove();
      if (onlyImage)
        this.showFilemanagerModal(true, 'image');
      else
        this.showFilemanagerModal(true);
    }

    // let dropzone = new Dropzone(".dropzone");
    // dropzone.on("success", function (file, response)
    // {
    //   if (response.ok)
    //   {
    //     fileManager.renderFiles(response, true);
    //   }
    // });
    // $('#filemanagerTypeSelect').selectpicker();
    // $('#filemanager-files-owner').selectpicker();

    this.initiated = true;
  }
  else
  {
    if (multiple)
      $('#filemanager-uploaded-files-list').addClass('multiple');
    else
      $('#filemanager-uploaded-files-list').removeClass('multiple');
    $('#filemanager-modal .title h2').text(title);
    this.showFilemanagerModal();
  }
};
fileManager.selectFile=function ()
{
  let selectedFiles=[];
  $('.file-item.selected').each(function ()
  {
    let id = $(this).data('id');
    if (typeof fileManager.files[id] !== "undefined")
      selectedFiles.push(fileManager.files[id]);
    $(this).removeClass('selected');
  });
  if (selectedFiles.length > 0)
  {
    if (typeof this.onSelectFunction === "function")
    {
      try
      {
        this.onSelectFunction(selectedFiles)
      }
      catch (e)
      {
        console.log(e)
      }
    }
    this.hideFilemanagerModal();
  }
  else{
    this.notify('danger','هیچ فایلی انتخاب نکرده اید.')
  }
  return selectedFiles;
};
fileManager.onSelect=function (func)
{
  if (typeof func === "function")
    this.onSelectFunction = func;
};


window.fileManagerSaveInfoCallback = function (data)
{
  if (data)
  {
    data.result = !!data.ok;
    showSystemNoti(data.result, data.message);
    if (data.ok && data.index && data.file)
    {
      fileManager.files[data.index] = data.file;
    }
  }
}


window.deleteFileCallback = function (data)
{
  if (data)
  {
    let element = $('#deleteBtnModal');
    element.modal('hide');
    try
    {
      setTimeout(function ()
      {
        if (data.ok)
        {
          $('#file-item-' + data.id).parent().remove();
          $('.file_info').html('');
          showSystemNoti('success', data.message);
        }
        else
          showSystemNoti('error', data.error);
      }, 200);
    } catch (e)
    {
      $('.shouldDelete').toggleClass('shouldDelete');
      showSystemNoti('danger', 'خطا در برقرای ارتباط با سرور')
    }
  }
}


$(document).ready(function ()
{

  $(this).delegate('.filemanager-list-files-wrapper .file-item','click',function ()
  {
    let id;
    let currentElement = $(this);
    if (!$('.filemanager-list-files-wrapper').hasClass('multiple')) {
      let flag = currentElement.hasClass('selected');
      $('.filemanager-list-files-wrapper .file-item').removeClass('selected');
      if (flag)
        currentElement.removeClass('selected');
      else
        currentElement.addClass('selected');
    }
    else
      $(this).toggleClass('selected');
    id = currentElement.data('id');
    fileManager.showFileInfo(id)
  });

  $(this).delegate('.show-file-info-btn','click',function ()
  {
    $(this).toggleClass('closed');
    $(this).siblings('.file_info').toggleClass('closed')
  });


  $(this).delegate('#filemanagerTypeSelect','change',function ()
  {
    fileManager.clearFileList();
    fileManager.getFiles(0,20,$(this).val(),$('#filemanagerQuery').val());
  });

  let lastFileSearchQuery;
  $(this).delegate('#filemanagerQuery','keyup',function ()
  {
    let query=null;
    let val = $(this).val();
    if (val && val.length)
      query=val;
    if (lastFileSearchQuery !== query)
    {
      fileManager.clearFileList();
      lastFileSearchQuery=query;
      fileManager.getFiles(0, 20, $('#filemanagerTypeSelect').val(), query);
    }
  });

  $(this).delegate('.filemanager-files-pagination .pagination a','click',function ()
  {
    if (!$(this).parent().hasClass('active'))
    {
      fileManager.clearFileList();
      let offset = $(this).data('offset');
      if (!offset)
        offset = 0;
      fileManager.getFiles(offset, 20, $('#filemanagerTypeSelect').val(), $('#filemanagerQuery').val());
    }
  });



  $(this).delegate('#filemanager-modal-overlay','click',function ()
  {
    fileManager.hideFilemanagerModal();
  });

  $(this).delegate('#close-filemanager-modal','click',function ()
  {
    fileManager.hideFilemanagerModal();
  });

  $(this).delegate('#filemanager-select-item','click',function ()
  {
    fileManager.selectFile();
  });

  $(this).delegate('.image-picker img','click',function ()
  {
    let element = $(this).parent();
    fileManager.init(false,false,true);
    fileManager.onSelect(function (data)
    {
      data=data[0];
      let html = '<div class="remove-picked-image"><i class="fa fa-times-circle"></i></div>';
      element.find('.attachment-id').val(data._id);
      element.find('.img-preview').attr('src',data.url);
      if (!element.find('.remove-picked-image').length)
      {
        element.prepend(html);
      }
    })
  });

  $(this).delegate('.add-gallery-image','click',function ()
  {
    let element = $(this);
    let name=element.data('name');
    if (typeof name === 'undefined')
      name='';
    name+='[]';

    let onlyImage = true;
    const anyFile = element.data('any-files');
    if (anyFile)
      onlyImage = false;
    fileManager.init(false,true,onlyImage);
    fileManager.onSelect(function (data)
    {
      // try
      // {
        for (let j = 0; j < data.length; j++)
        {
          let file=data[j];

          let html='<div class="gallery-item">' +
            '<div class="remove-gallery-item"><i class="fa fa-times-circle"></i></div>' +
            '<input type="hidden" name="'+name+'" value="'+file._id+'" />';

          let thumbnail = fileManager.options.imgUrl+'document.png';
          if (file.type === 'image')
            thumbnail = fileManager.options.storageUrl+file.thumbnail;
          else if (file.type === 'audio')
            thumbnail = fileManager.options.imgUrl+'audio.png';
          else if (file.type === 'video')
            thumbnail = fileManager.options.imgUrl+'video.png';

          if (file.type === 'image')
            html+='<img src="'+thumbnail+'">';
          else
            html+='<a href="'+fileManager.options.storageUrl+file.name+'" target="_blank"><img src="'+thumbnail+'"></a>';

          html+= '</div>';
          element.parent().find('.gallery-images').append(html);
        }
      // }
      // catch (e)
      // {
      //
      // }
    })
  });

  $(this).delegate('.remove-gallery-item','click',function ()
  {
    $(this).parent().remove();
  });

  $(this).delegate('.remove-picked-image','click',function ()
  {
    $(this).parent().find('img').attr('src',HOST+'/panel/img/image-icon.png');
    $(this).parent().find('input').val('');
    $(this).remove();
  });

  $(this).delegate('.file-picker-container button','click',function (e)
  {
    e.stopPropagation();
    let name = $(this).attr('data-name');
    if (typeof name === "undefined")
      name='file_id';
    let element = $(this).parent();
    fileManager.init(false,false,false);
    fileManager.onSelect(function (data)
    {
      data=data[0];
      if (!element.find('.file-view').length)
      {
        let html= '<div class="m-b-5"><div class="btn bg-cyan file-view"></div>\n' +
          '<input type="hidden" class="'+name+'" name="'+name+'" /></div>';
        element.prepend(html);
      }

      element.find('input').val(data._id);
      element.find('.file-view').text(data.name);
    })
  });



  $(this).delegate('.car_part_image_picker','click',function (e)
  {
    e.stopPropagation();
    let element = $(this).parent();
    fileManager.init(false,false,true);
    fileManager.onSelect(function (data)
    {
      data = data[0];
      let html= '<img class="img-fluid car_part_pic" src="'+data.url+'">';
      element.siblings('.car_part_pic_container').html(html).parent().find('.pic_id').val(data._id);
    });
  });

  $(this).delegate('#upload-trigger','click',function (){
    $('#upload-file-input').trigger('click')
  })

  $(this).delegate('#upload-file-input','change',async function (){
    const formData = new FormData();
    const imagefile = document.querySelector('#upload-file-input');
    formData.append("file", imagefile.files[0]);
    const url = process.env.VUE_APP_API_URL+process.env.VUE_APP_API_PATH+fileManager.options.uploadRoute;
    const result = await jwtInterceptor.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    if (result && result.data && result.data)
    {
      fileManager.renderFiles(result.data, true);
    }
  })

});
